/* eslint-disable no-undef */
import { gTagEvent } from './gTag';
import { EVENTS_CONST, SUBSCRIPTION_ACTIVATE_EVENT_CONFIG, SUBSCRIPTION_ACTIVATE_EVENT_FIELD_CONST } from './constants';

let hasCleverTapLoaded = false;
window.onload = () => {
  hasCleverTapLoaded = true;
};

function getUserProfile(userDetails = {}) {
  const profile = {
    Email: userDetails.email,
  };
  return {
    Site: profile
  };
}
// creates a new user session with pushed user profile details
export function logInAppProfile(userDetails = {}) {
  const userProfile = getUserProfile(userDetails);
  clevertap.onUserLogin.push(userProfile);
}

// updates the pushed user profile
export function cleverTapPushProfile(userDetails = {}) {
  const userProfile = getUserProfile(userDetails);
  clevertap.profile.push(userProfile);
}

// log the event when user change email
export function changeEmail() {
  clevertap.event.push(EVENTS_CONST.changeEmail);
  gTagEvent(EVENTS_CONST.changeEmail);
}

// log the event when user change password
export function changePassword() {
  clevertap.event.push(EVENTS_CONST.changePassword);
  gTagEvent(EVENTS_CONST.changePassword);
}

// log the event when user click delete account
export function clickDataPolicyDeleteAccount() {
  clevertap.event.push(EVENTS_CONST.clickDataPolicyDeleteAccount);
  gTagEvent(EVENTS_CONST.clickDataPolicyDeleteAccount);
}

// log the event when user delete account completed
export function deleteAccountSuccess() {
  clevertap.event.push(EVENTS_CONST.deleteAccountSuccess);
  gTagEvent(EVENTS_CONST.deleteAccountSuccess);
}

// updated user profile into clever tap and push 'login' event
export function logInApp(profile) {
  cleverTapPushProfile(profile);
  clevertap.event.push(EVENTS_CONST.logInApp); // as user enters into main app
  gTagEvent(EVENTS_CONST.logInApp);
}

// log the event when user clicks on Logout at Popover in Header of Professional layout
export function clickSignOutApp() {
  clevertap.event.push(EVENTS_CONST.clickSignOutApp);
  gTagEvent(EVENTS_CONST.clickSignOutApp);
}

// log the event when user click on "Contact Us" link in Menu
export function clickMenuContactUs() {
  clevertap.event.push(EVENTS_CONST.clickMenuContactUs);
  gTagEvent(EVENTS_CONST.clickMenuContactUs);
}

// log the event when user click on "Setting" link in Menu
export function clickMenuSettings() {
  clevertap.event.push(EVENTS_CONST.clickMenuSettings);
  gTagEvent(EVENTS_CONST.clickMenuSettings);
}

// log the event when user click on "Data Policy" link in Menu
export function clickMenuDataPolicy() {
  clevertap.event.push(EVENTS_CONST.clickMenuDataPolicy);
  gTagEvent(EVENTS_CONST.clickMenuDataPolicy);
}

// log the event when user click on "Confirm delete account" button in Modal
export function clickConfirmDeleteAccount() {
  clevertap.event.push(EVENTS_CONST.clickConfirmDeleteAccount);
  gTagEvent(EVENTS_CONST.clickConfirmDeleteAccount);
}

// log the event when user click on "Select Plan" button in Muse Plans Page
export function checkoutMusePlans() {
  clevertap.event.push(EVENTS_CONST.checkoutMusePlans);
  gTagEvent(EVENTS_CONST.checkoutMusePlans);
}

// log the event when user click on "terms or services" link in Muse Plans Page
export function clickMusePlansTos() {
  clevertap.event.push(EVENTS_CONST.clickMusePlansTos);
  gTagEvent(EVENTS_CONST.clickMusePlansTos);
}

// log the event when user click on "click here" link in Muse Plans Page
export function clickMusePlansBillingInvoicesLink() {
  clevertap.event.push(EVENTS_CONST.clickMusePlansBillingInvoicesLink);
  gTagEvent(EVENTS_CONST.clickMusePlansBillingInvoicesLink);
}

// log the event when user click on "contact us" link in Muse Plans Page
export function clickMusePlansContactus() {
  clevertap.event.push(EVENTS_CONST.clickMusePlansContactus);
  gTagEvent(EVENTS_CONST.clickMusePlansContactus);
}

// log the event when user click on "Select Plan" button in Muse Trial Plans Page
export function checkoutMuseTrialPlans() {
  clevertap.event.push(EVENTS_CONST.checkoutMuseTrialPlans);
  gTagEvent(EVENTS_CONST.checkoutMuseTrialPlans);
}

// log the event when user click on "terms or services" link in Muse Trial Plans Page
export function clickMuseTrialPlansTos() {
  clevertap.event.push(EVENTS_CONST.clickMuseTrialPlansTos);
  gTagEvent(EVENTS_CONST.clickMuseTrialPlansTos);
}

// log the event when user click on "contact us" link in Muse Trial Plans Page
export function clickMuseTrialPlansContactus() {
  clevertap.event.push(EVENTS_CONST.clickMuseTrialPlansContactus);
  gTagEvent(EVENTS_CONST.clickMuseTrialPlansContactus);
}

// log the event when user click on "Select Plan" button in Muse Android Promo Plans Page
export function checkoutMuseAndroidPromoPlans() {
  clevertap.event.push(EVENTS_CONST.checkoutMuseAndroidPromoPlans);
  gTagEvent(EVENTS_CONST.checkoutAndroidPromoPlans);
}

// log the event when user click on "terms or services" link in Muse Android Promo Plans Page
export function clickMuseAndroidPromoPlansTos() {
  clevertap.event.push(EVENTS_CONST.clickMuseAndroidPromoPlansTos);
  gTagEvent(EVENTS_CONST.clickMuseAndroidPromoPlansTos);
}

// log the event when user click on "contact us" link in Muse Android Promo Plans Page
export function clickMuseAndroidPromoPlansContactus() {
  clevertap.event.push(EVENTS_CONST.clickMuseAndroidPromoPlansContactus);
  gTagEvent(EVENTS_CONST.clickMuseAndroidPromoPlansContactus);
}

// log the event when user click on "Select Plan" button in Ms Plans Page
export function checkoutMsPlans() {
  clevertap.event.push(EVENTS_CONST.checkoutMsPlans);
  gTagEvent(EVENTS_CONST.checkoutMPlans);
}

// log the event when user click on "terms or services" link in Ms Plans Page
export function clickMsPlansTos() {
  clevertap.event.push(EVENTS_CONST.clickMsPlansTos);
  gTagEvent(EVENTS_CONST.clickMsPlansTos);
}

// log the event when user click on "click here" link in Ms Plans Page
export function clickMsPlansBillingInvoicesLink() {
  clevertap.event.push(EVENTS_CONST.clickMsPlansBillingInvoicesLink);
  gTagEvent(EVENTS_CONST.clickMsPlansBillingInvoicesLink);
}

// log the event when user click on "contact us" link in Ms Plans Page
export function clickMsPlansContactus() {
  clevertap.event.push(EVENTS_CONST.clickMsPlansContactus);
  gTagEvent(EVENTS_CONST.clickMsPlansContactus);
}

// log the event when user click on "Select Plan" button in Direct Page Android
export function checkoutMuseDirectPlansAndroid() {
  clevertap.event.push(EVENTS_CONST.checkoutMuseDirectPlansAndroid);
  gTagEvent(EVENTS_CONST.checkoutMuseDirectPlansAndroid);
}

// log the event when user click on "terms or services" link in Direct Page Android
export function clickMuseDirectPlansAndroidTos() {
  clevertap.event.push(EVENTS_CONST.clickMuseDirectPlansAndroidTos);
  gTagEvent(EVENTS_CONST.clickMuseDirectPlansAndroidTos);
}

// log the event when user click on "click here" link in Direct Page Android
export function clickMuseDirectPlansAndroidBillingInvoicesLink() {
  clevertap.event.push(EVENTS_CONST.clickMuseDirectPlansAndroidBillingInvoicesLink);
  gTagEvent(EVENTS_CONST.clickMuseDirectPlansAndroidBillingInvoicesLink);
}

// log the event when user click on "contact us" link in Direct Page Android
export function clickMuseDirectPlansAndroidContactus() {
  clevertap.event.push(EVENTS_CONST.clickMuseDirectPlansAndroidContactus);
  gTagEvent(EVENTS_CONST.clickMuseDirectPlansAndroidContactus);
}

// log the event when user click on "Select Plan" button in Direct Page Windows
export function checkoutMuseDirectPlansWindows() {
  clevertap.event.push(EVENTS_CONST.checkoutMuseDirectPlansWindows);
  gTagEvent(EVENTS_CONST.checkoutMuseDirectPlansWindows);
}

// log the event when user click on "terms or services" link in Direct Page Windows
export function clickMuseDirectPlansWindowsTos() {
  clevertap.event.push(EVENTS_CONST.clickMuseDirectPlansWindowsTos);
  gTagEvent(EVENTS_CONST.clickMuseDirectPlansWindowsTos);
}

// log the event when user click on "click here" link in Direct Page Windows
export function clickMuseDirectPlansWindowsBillingInvoicesLink() {
  clevertap.event.push(EVENTS_CONST.clickMuseDirectPlansWindowsBillingInvoicesLink);
  gTagEvent(EVENTS_CONST.clickMuseDirectPlansWindowsBillingInvoicesLink);
}

// log the event when user click on "contact us" link in Direct Page Windows
export function clickMuseDirectPlansWindowsContactus() {
  clevertap.event.push(EVENTS_CONST.clickMuseDirectPlansWindowsContactus);
  gTagEvent(EVENTS_CONST.clickMuseDirectPlansWindowsContactus);
}

// logs out the user from clevertap as logout event dispatch in system.
export function cleverTapLogout() {
  if (hasCleverTapLoaded && clevertap.logout) {
    clevertap.logout();
  }
}

/**
 * log the event when user click on "Continue" button in Address details
 * section of Subscription Activate view
 */
export function clickSubscriptionActivateAddressDetailsButton() {
  clevertap.event.push(EVENTS_CONST.addressDetailsContinueSubmitted);
  gTagEvent(EVENTS_CONST.addressDetailsContinueSubmitted,
    SUBSCRIPTION_ACTIVATE_EVENT_CONFIG);
}

/**
 * log the event when user click on "Activate Now" button in Payment
 * section of Subscription Activate view
 */
export function clickSubscriptionActivatePaymentDetailsButton() {
  clevertap.event.push(EVENTS_CONST.paymentDetailsActivateNowSubmitted);
  gTagEvent(EVENTS_CONST.paymentDetailsActivateNowSubmitted,
    SUBSCRIPTION_ACTIVATE_EVENT_CONFIG);
}

// log the event when user starts to input value in input field of Subscription Activate sections
export function changeSubscriptionActivateFields(fieldName) {
  const eventAction = getSubscriptionActivateEventName(fieldName);
  if (eventAction) {
    clevertap.event.push(eventAction);
    gTagEvent(eventAction,
      SUBSCRIPTION_ACTIVATE_EVENT_CONFIG);
  }
}

export function getSubscriptionActivateEventName(eventName) {
  const {
    ACTIVATION_CODE_DETAILS_ACTIVATION_CODE,
    ACCOUNT_DETAILS_EMAIL,
    ACCOUNT_DETAILS_PASSWORD,
    ACCOUNT_DETAILS_FIRST_NAME,
    ACCOUNT_DETAILS_LAST_NAME,
    ACCOUNT_DETAILS_BIRTHDATE,
    ADDRESS_DETAILS_FIRST_NAME,
    ADDRESS_DETAILS_LAST_NAME,
    ADDRESS_DETAILS_ADDRESS,
    ADDRESS_DETAILS_EXTENDED_ADDRESS,
    ADDRESS_DETAILS_CITY,
    ADDRESS_DETAILS_COUNTRY,
    ADDRESS_DETAILS_REGION,
    ADDRESS_DETAILS_ZIP_CODE,
    ADDRESS_DETAILS_PHONE_NUMBER,
    PAYMENT_FULL_NAME,
    PAYMENT_CARD_NUMBER,
    PAYMENT_EXPIRY,
    PAYMENT_CVV
  } = SUBSCRIPTION_ACTIVATE_EVENT_FIELD_CONST;
  const eventConfig = {
    [ACTIVATION_CODE_DETAILS_ACTIVATION_CODE]:
      EVENTS_CONST.activationCodeDetailsActivationCodeFilled,
    [ACCOUNT_DETAILS_EMAIL]: EVENTS_CONST.accountDetailsEmailFilled,
    [ACCOUNT_DETAILS_PASSWORD]: EVENTS_CONST.accountDetailsPasswordFilled,
    [ACCOUNT_DETAILS_FIRST_NAME]: EVENTS_CONST.accountDetailsFirstNameFilled,
    [ACCOUNT_DETAILS_LAST_NAME]: EVENTS_CONST.accountDetailsLastNameFilled,
    [ACCOUNT_DETAILS_BIRTHDATE]: EVENTS_CONST.accountDetailsDOBFilled,
    [ADDRESS_DETAILS_FIRST_NAME]: EVENTS_CONST.addressDetailsFirstNameFilled,
    [ADDRESS_DETAILS_LAST_NAME]: EVENTS_CONST.addressDetailsLastNameFilled,
    [ADDRESS_DETAILS_ADDRESS]: EVENTS_CONST.addressDetailsAddressFilled,
    [ADDRESS_DETAILS_EXTENDED_ADDRESS]: EVENTS_CONST.addressDetailsApartmentFilled,
    [ADDRESS_DETAILS_CITY]: EVENTS_CONST.addressDetailsCityFilled,
    [ADDRESS_DETAILS_COUNTRY]: EVENTS_CONST.addressDetailsCountryFilled,
    [ADDRESS_DETAILS_REGION]: EVENTS_CONST.addressDetailsRegionFilled,
    [ADDRESS_DETAILS_ZIP_CODE]: EVENTS_CONST.addressDetailsZipCodeFilled,
    [ADDRESS_DETAILS_PHONE_NUMBER]: EVENTS_CONST.addressDetailsPhoneNumberFilled,
    [PAYMENT_FULL_NAME]: EVENTS_CONST.paymentDetailsFullNameFilled,
    [PAYMENT_CARD_NUMBER]: EVENTS_CONST.paymentDetailsCardNumberFilled,
    [PAYMENT_EXPIRY]: EVENTS_CONST.paymentDetailsCardExpiryFilled,
    [PAYMENT_CVV]: EVENTS_CONST.paymentDetailsCardCVVFilled
  };
  return eventConfig[eventName];
}

export default {
  changeEmail,
  changePassword,
  clickDataPolicyDeleteAccount,
  deleteAccountSuccess,
  logInApp,
  clickSignOutApp,
  clickMenuContactUs,
  cleverTapLogout,
  clickMenuSettings,
  clickMenuDataPolicy,
  clickConfirmDeleteAccount,
  clickMusePlansBillingInvoicesLink,
  clickMusePlansContactus,
  checkoutMuseDirectPlansAndroid,
  clickMuseDirectPlansAndroidTos,
  clickMuseDirectPlansAndroidBillingInvoicesLink,
  clickMuseDirectPlansAndroidContactus,
  checkoutMuseDirectPlansWindows,
  clickMuseDirectPlansWindowsTos,
  clickMuseDirectPlansWindowsBillingInvoicesLink,
  clickMuseDirectPlansWindowsContactus
};



// WEBPACK FOOTER //
// ./src/libs/cleverTap.js